var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('audio',{ref:"audio",staticStyle:{"display":"none"},attrs:{"id":"audio","preload":"auto","src":_vm.audioSrc,"controls":"controls"},on:{"pause":_vm.onPauseHandler,"ended":_vm.endedHandler,"play":_vm.onPlayHandler,"timeupdate":_vm.onTimeupdateHandler,"loadedmetadata":_vm.onLoadedmetadataHandler,"canplay":_vm.canplayHandler}})])
}
var staticRenderFns = []

export { render, staticRenderFns }